import { render } from "./MainPageDateSelector.vue?vue&type=template&id=50481a08&scoped=true&ts=true"
import script from "./MainPageDateSelector.vue?vue&type=script&lang=ts"
export * from "./MainPageDateSelector.vue?vue&type=script&lang=ts"

import "./MainPageDateSelector.vue?vue&type=style&index=0&id=50481a08&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50481a08"]])

export default __exports__